import React, {useEffect} from 'react'
import CssBaseline from "@mui/material/CssBaseline";
import {Route, Routes, Navigate, useLocation } from "react-router-dom";
import IndexPage from "../../pages/IndexPage/IndexPage";
import NotFoundPage from "../../pages/NotFoundPage/NotFoundPage";
import DAPage from "../../pages/DAPage/DAPage";
import DEPage from "../../pages/DEPage/DEPage";
import OrganizersPage from "../../pages/OrganizersPage/OrganizersPage";
import PrizesPage from "../../pages/PrizesPage/PrizesPage";
import SponsorsPage from "../../pages/SponsorsPage/SponsorsPage";
import TimeLinePage from "../../pages/TimeLinePage/TimeLinePage";
import ProductPage from "../../pages/ProductPage/ProductPage";
import ServicePage from "../../pages/ServicePage/ServicePage";
import RulesPage from "../../pages/RulesPage/RulesPage";

import { initializeAnalytics, trackPageView } from '../utils/analytics';

const MainArea: React.FC = () => {
    const location = useLocation();
    useEffect(() => {
        initializeAnalytics(); // Инициализация один раз
        trackPageView(location.pathname); // Отслеживание страницы
    }, [location]);
    return(
        <>
            <CssBaseline />
            <div>
                <Routes>
                    <Route path='/' element={ <IndexPage /> }/>
                    <Route path='/rules' element={ <RulesPage />}/>
                    <Route path='/product' element={ <ProductPage />}/>
                    <Route path='/service' element={ <ServicePage />}/>
                    {/*<Route path='/da' element={ <DAPage />}/>*/}
                    {/*<Route path='/de' element={ <DEPage />}/>*/}
                    <Route path='/organizers' element={ <OrganizersPage />}/>
                    <Route path='/prizes' element={ <PrizesPage />}/>
                    <Route path='/sponsors' element={ <SponsorsPage />}/>
                    <Route path='/timeline' element={ <TimeLinePage />}/>
                    <Route path='/404' element={ <NotFoundPage />}/>
                    <Route path="*" element={ <Navigate to="/404" />}/>
                </Routes>
            </div>
        </>
    )
}

export default MainArea;